import React from "react";
import { Typography } from "@mui/material";

export const State = ({className, children}) => {
  return (
    <div className={`tag-status ${className}`}>
      <Typography variant="body2" noWrap>{children}</Typography>
    </div>
  )
}